import { Dialog } from "vant";

function WarningMsgBox(message){
    Dialog.alert({
        title: '提 示',
        message: `<span style="color:#ff9933">${message}</span>`,
        confirmButtonColor: '#1989fa',
        theme: 'round-button',
        width: '300px',
    }).then(() => {
        // 在此可以添加确认后的回调逻辑
        return;
    });
}

export{
    WarningMsgBox
}